import React from 'react';
import {
  basePatchQuery,
  uploadSingleImage,
} from '../../../../utility/sb-api/sb-api.service';
import {
  closeModalSafely as closeModalSafelyBase,
  getTranslationsCollapsable as getTranslationsCollapsableBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (
  event,
  errors,
  values,
  uploadImage,
  targetMenu,
  setIsSubmitting,
  setTargetMenu,
  closeModal,
  onSubmit,
  storeId,
) => {
  if (!errors?.length > 0) {
    setIsSubmitting(true);

    // if the image was deleted, targetItemData.image will be set to null.
    // as targetItemData.image.id is undefined then, Promise.resolve will return null
    (uploadImage
      ? uploadSingleImage(uploadImage, storeId).then((res) => res.id)
      : Promise.resolve(targetMenu?.coverImage?.id || null)
    )
      .then((imageId) => {
        const preparedValues = {
          coverImageId: imageId,
          coverImage: undefined,
          ...values,
        };

        const path = storeId
          ? `manager/stores/${storeId}/menus/${targetMenu.id}`
          : `menus/${targetMenu.id}`;

        return basePatchQuery(
          path,
          preparedValues,
          null,
          'editMenuCoverSuccess',
          'editMenuCoverError',
        );
      })
      .then(() => {
        onSubmit();
        setIsSubmitting(false);
        setTargetMenu({});
        closeModal();
      })
      .catch(() => setIsSubmitting(false));
  } else {
    console.error('Got validation errors in ' + errors.join(', '));
  }
};

export const getTranslationsCollapsable = getTranslationsCollapsableBase;
